import { TableExporterType } from '@baserow/modules/database/exporterTypes'
import { GridViewType } from '@baserow/modules/database/viewTypes'

/**
 * Los tres formatos que Baserow deja tras el paywall de "Table export". El
 * trabajo de verdad esta en el backend (extras_mg/export/exporter_types.py);
 * esto solo los ofrece en el menu.
 *
 * Sin getFormComponent: ninguno de los tres tiene opciones que pedir. El CSV si
 * lo trae porque necesita separador y codificacion.
 */

export class ExcelTableExporterType extends TableExporterType {
  // Mismo nombre de tipo que el de premium a proposito: lo reemplaza, asi el
  // menu no muestra dos veces "Excel" (una funcionando y otra pidiendo pagar).
  static getType() {
    return 'excel'
  }

  getIconClass() {
    return 'baserow-icon-file-excel'
  }

  getName() {
    return 'Excel (.xlsx)'
  }

  getCanExportTable() {
    return true
  }

  getSupportedViews() {
    return [GridViewType.getType()]
  }
}

export class JSONTableExporterType extends TableExporterType {
  static getType() {
    return 'json'
  }

  getIconClass() {
    return 'baserow-icon-file-code'
  }

  getName() {
    return 'JSON'
  }

  getCanExportTable() {
    return true
  }

  getSupportedViews() {
    return [GridViewType.getType()]
  }
}

export class XMLTableExporterType extends TableExporterType {
  static getType() {
    return 'xml'
  }

  getIconClass() {
    return 'baserow-icon-file-code'
  }

  getName() {
    return 'XML'
  }

  getCanExportTable() {
    return true
  }

  getSupportedViews() {
    return [GridViewType.getType()]
  }
}

export class ArchivosTableExporterType extends TableExporterType {
  static getType() {
    return 'file'
  }

  getIconClass() {
    return 'baserow-icon-file-archive'
  }

  getName() {
    return 'Archivos adjuntos (.zip)'
  }

  getCanExportTable() {
    return true
  }

  getSupportedViews() {
    return [GridViewType.getType()]
  }
}
